<template>
  <div>
    <form
      class="form"
      method="POST"
      action="javascript:;"
      @submit.prevent="submit"
    >
      <FormError v-if="formError.length > 0" :errorMessages="formError" />

      <FormLoading v-if="!formReady" />

      <CardBase v-else>
        <template #header>{{ $route.meta.title }}</template>
        <template #content>
          <FormNote class="mb-6"
            >Note: Jika password dirubah maka user tersebut akan ter<em
              >logout</em
            >
            secara otomatis dan harus melakukan <em>login</em> ulang
            kembali.</FormNote
          >
          <FormRow class="mb-4" :required="true">
            <template #label>Name</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.name.$error && formSubmitted,
                }"
                type="text"
                class="form__input"
                placeholder="Name"
                v-model.trim="formData.name"
                v-focus
              />
              <div
                class="form-error"
                v-if="$v.formData.name.$error && formSubmitted"
              >
                <span class="form-error__text" v-if="!$v.formData.name.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Username</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.username.$error && formSubmitted,
                  'form__input--readonly': !formCreate
                }"
                type="text"
                class="form__input"
                placeholder="Username"
                v-model.trim="formData.username"
                :readonly="!formCreate"
                :disabled="!formCreate"
              />
              <div
                class="form-error"
                v-if="$v.formData.username.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.username.required"
                  >This field is required.</span
                >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.username.alphaNum"
                  >Only letters and numbers are allowed. No spaces, underscores
                  or any special characters.</span
                >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.username.minLength"
                  >Username must be at least
                  {{ $v.formData.username.$params.minLength.min }}
                  characters.</span
                >
              </div>
            </template>
            <template #help>This username will be used for login.</template>
          </FormRow>

          <FormRow class="mb-4" :required="formCreate">
            <template #label>Password</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.password.$error && formSubmitted,
                }"
                type="password"
                class="form__input"
                placeholder="*****"
                v-model="formData.password"
              />
              <div
                class="form-error"
                v-if="$v.formData.password.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.password.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="formCreate">
            <template #label>Re-enter Password</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.password_confirmation.$error && formSubmitted,
                }"
                type="password"
                class="form__input"
                placeholder="*****"
                v-model="formData.password_confirmation"
              />
              <div
                class="form-error"
                v-if="$v.formData.password_confirmation.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.password_confirmation.required"
                  >This field is required.</span
                >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.password_confirmation.sameAsPassword"
                  >Please enter the same password.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Asset Group</template>
            <template #field>
              <multiselect
                :allow-empty="false"
                deselectLabel=""
                :options="listGroup"
                :loading="listGroupLoading"
                :class="$v.formData.group.$error ? 'multiselect--error' : ''"
                track-by="id"
                label="code_name"
                placeholder="Choose group"
                v-model="formData.group"
                @input="chooseGroup"
                :disabled="!formCreate"
              >
                <template #noResult>No results found.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.group.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.group.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Role</template>
            <template #field>
              <multiselect
                :allow-empty="false"
                deselectLabel=""
                :options="listUserRole"
                :loading="listUserRoleLoading"
                :class="$v.formData.role.$error ? 'multiselect--error' : ''"
                track-by="id"
                label="name"
                :placeholder="
                  !formData.group
                    ? 'Please select group first'
                    : 'Choose role in group ' + formData.group.code_name
                "
                v-model="formData.role"
              >
                <template #noOptions v-if="!formData.group"
                  >Please select group first</template
                >
                <template #noResult>No results found.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.role.$error && formSubmitted"
              >
                <span class="form-error__text" v-if="!$v.formData.role.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4">
            <template #label>Allow access to all assets?</template>
            <template #field>
              <div>
                <label class="flex items-center mb-1 cursor-pointer">
                  <input
                    type="radio"
                    class="cursor-pointer"
                    value="1"
                    v-model="formData.all_asset"
                  />
                  <span class="ml-2 text-sm">Yes</span>
                </label>
                <label class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    class="cursor-pointer"
                    value="0"
                    v-model="formData.all_asset"
                  />
                  <span class="ml-2 text-sm">No</span>
                </label>
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" v-if="formData.all_asset == 0" :required="true">
            <template #label>Assets</template>
            <template #field>
              <multiselect
                :options="listAsset"
                :loading="listAssetLoading"
                :class="$v.formData.assets.$error ? 'multiselect--error' : ''"
                :multiple="true"
                :close-on-select="false"
                track-by="id"
                label="name"
                :placeholder="
                  !formData.group_id
                    ? 'Please select group first'
                    : 'Choose asset in ' + formData.group.code_name
                "
                v-model="formData.assets"
              >
                <template #noOptions>Enter asset name</template>
                <template #noResult>No results found</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.assets.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.assets.required"
                  >This field is required.</span
                >
              </div>
            </template>
            <template #help
              >This user will only be allowed to access the selected
              assets.</template
            >
          </FormRow>

          <FormRow class="mb-4" v-if="!formCreate">
            <template #label>Status</template>
            <template #field>
              <div>
                <label class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    class="cursor-pointer"
                    name="status"
                    value="1"
                    v-model="formData.status"
                  />
                  <span class="ml-2 text-sm">Active</span>
                </label>
                <label class="flex items-center my-1 cursor-pointer">
                  <input
                    type="radio"
                    class="cursor-pointer"
                    name="status"
                    value="0"
                    v-model="formData.status"
                  />
                  <span class="ml-2 text-sm">Inactive</span>
                </label>
                <label class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    class="cursor-pointer"
                    name="status"
                    value="2"
                    v-model="formData.status"
                  />
                  <span class="ml-2 text-sm">Banned</span>
                </label>
              </div>
            </template>
            <template #help
              >Inactive user will not be able to access the app.</template
            >
          </FormRow>

          <FormDataLog :data="formData" v-if="!formCreate" />
        </template>

        <template #footer>
          <FormRow class="mb-0">
            <template #field>
              <BaseButton type="submit">Submit</BaseButton>
            </template>
            <template #link>
              <div class="ml-4">
                or
                <router-link :to="{ name: 'UserList' }" class="link ml-2"
                  >Back to List Users</router-link
                >
              </div>
            </template>
          </FormRow>
        </template>
      </CardBase>
    </form>
    <Changelog v-if="!this.formCreate" />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {
  alphaNum,
  required,
  minLength,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";

import { submitFormMixin } from "@/mixins/submitFormMixin";

export default {
  mixins: [submitFormMixin],
  components: {
    Multiselect,
  },
  computed: {
    passwordRequired() {
      return this.formCreate;
    },
    assetRequired() {
      return !this.formData.all_asset;
    },
  },
  validations: {
    formData: {
      name: {
        required,
      },
      username: {
        required,
        alphaNum,
        minLength: minLength(3),
      },
      password: {
        required: requiredIf(function () {
          return this.passwordRequired;
        }),
      },
      password_confirmation: {
        required: requiredIf(function () {
          return this.passwordRequired;
        }),
        sameAsPassword: sameAs("password"),
      },
      group: {
        required,
      },
      role: {
        required,
      },
      assets: {
        required: requiredIf(function () {
          return this.assetRequired;
        }),
      },
    },
  },
  data: () => {
    return {
      listUserRole: [],
      listUserRoleLoading: false,

      listAsset: [],
      listAssetLoading: false,

      listGroup: [],
      listGroupLoading: false,

      formData: {
        all_asset: 0,
        assets: [],
      },
    };
  },
  created() {
    if (this.formCreate) {
      this.getListGroup();
    }

    // this.getListAsset();
  },
  methods: {
    chooseGroup(group) {
      delete this.formData.role;
      this.formData.assets = [];
      this.getListUserRole(group.id);
      this.getListAsset(group.id);
    },
    getListAsset(groupId) {
      this.listAssetLoading = true;

      this.listAsset = [];

      this.$http
        .get(process.env.VUE_APP_API_URL + "/profile/asset?group_id=" + groupId)
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listAsset = response.data;
            }
          }
        })
        .finally(() => {
          this.listAssetLoading = false;
        });
    },
    getListUserRole(groupId = "") {
      this.listUserRoleLoading = true;

      this.listUserRole = [];
      this.$http
        .get(process.env.VUE_APP_API_URL + "/role?create=1&group_id=" + groupId)
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listUserRole = response.data;
              this.listUserRoleLoading = false;
            }
          }
        });
    },
    getListGroup() {
      this.listGroupLoading = true;
      this.$http.get(process.env.VUE_APP_API_URL + "/group").then((res) => {
        if (res.status == 200) {
          const response = res.data;

          if (response) {
            this.listGroup = response.data;
            this.listGroupLoading = false;
          }
        }
      });
    },
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.formData = { ...this.formData, ...data };

            this.formReady = true;

            this.getListUserRole(data.group.id);
            this.getListAsset(data.group.id);
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
  },
};
</script>
